import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { ChatSessionService } from '../services/chat-session.service';

function replaceCurrentSessionId(url: string, sessionId: number): string {
  return url.replace(/(\/ai-studio\/session\/)current(?=\/|\(|\?|$)/, `$1${sessionId}`);
}

export const aiStudioCurrentSessionGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const sessionService = inject(ChatSessionService);

  if (!/\/ai-studio\/session\/current(?=\/|\(|\?|$)/.test(state.url)) {
    return true;
  }

  return sessionService.initialLoadComplete$.pipe(
    filter(initialLoadComplete => initialLoadComplete),
    take(1),
    switchMap(() => sessionService.sessions$.pipe(take(1))),
    map(sessions => {
      const sessionId = sessionService.getActiveSessionIdSnapshot() ?? sessions[0]?.sessionId ?? null;
      if (sessionId === null) {
        return router.parseUrl('/ai-studio');
      }

      return router.parseUrl(replaceCurrentSessionId(state.url, sessionId));
    })
  );
};
